import axios from '../utils/axios';

export default function fetchCompetitionInstitute(adminId, params) {
    
    return (
        axios.get('/admin/' + adminId + '/competition/v2/competition/asset/institute', { params })
    )
}
